import React, { Fragment, useState } from "react";
import { Link } from "react-router-dom";
import Collapse from "@mui/material/Collapse";
import "./style.css";

interface MenuItem {
  id: number;
  title: string;
  link: string;
  submenu?: MenuItem[];
}

const menus: MenuItem[] = [
  {
    id: 1,
    title: "Home",
    link: "/",
  },
  {
    id: 2,
    title: "About Us",
    link: "/about",
  },
  {
    id: 3,
    title: "Products",
    link: "#",
    submenu: [
      { id: 31, title: "CAPRO: AI Receptionist", link: "/products/capro" },
      { id: 34, title: "SAPRO: AI Sales Agent", link: "/products/sapro" },
      { id: 32, title: "VAPRO: AI Social Media", link: "/products/vapro" },
      { id: 33, title: "HAPRO: AI Hiring Agent", link: "/products/hapro" },
      { id: 35, title: "TAPRO: AI Training Agent", link: "/products/tapro" },
      { id: 36, title: "INPRO: AI Business Intelligence", link: "/products/inpro" },
    ],
  },
  {
    id: 6,
    title: "Pricing",
    link: "/pricing",
  },
  {
    id: 4,
    title: "Case Studies",
    link: "/case-studies",
  },
  {
    id: 5,
    title: "Contact Us",
    link: "/contact",
  },
];

interface MobileMenuProps {
  closeMenu?: () => void;
}

const MobileMenu: React.FC<MobileMenuProps> = ({ closeMenu }) => {
  const [openId, setOpenId] = useState<number | null>(null);

  const handleToggle = (id: number) => {
    setOpenId(openId === id ? null : id);
  };

  const handleClick = () => {
    window.scrollTo(0, 0);
    if (closeMenu) {
      closeMenu();
    }
  };

  return (
    <ul className="responsivemenu">
      {menus.map((menu) => (
        <li key={menu.id} className={openId === menu.id ? "active" : ""}>
          {menu.submenu ? (
            <Fragment>
              <p onClick={() => handleToggle(menu.id)}>
                {menu.title}
                <i
                  className={
                    openId === menu.id ? "fa fa-angle-up" : "fa fa-angle-down"
                  }
                ></i>
              </p>

              {/* MUI Collapse for smooth animation */}
              <Collapse in={openId === menu.id} timeout="auto" unmountOnExit>
                <ul className="subMenu">
                  {menu.submenu.map((sub) => (
                    <li key={sub.id}>
                      <Link to={sub.link} onClick={handleClick}>
                        {sub.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </Collapse>
            </Fragment>
          ) : (
            <Link to={menu.link} onClick={handleClick}>
              {menu.title}
            </Link>
          )}
        </li>
      ))}
    </ul>
  );
};

export default MobileMenu;
